// src/Skills.jsx
import React from 'react';

const skillsData = [
  { skill: 'Python', level: 95, category: 'Programming' },
  { skill: 'Matlab', level: 95, category: 'Programming' },
  { skill: 'LaTeX', level: 90, category: 'Docs' },
  { skill: 'Microsoft Office (Excel, Word, PowerPoint)', level: 90, category: 'Docs' },
];

const Skill = () => {
  const programming = skillsData.filter(s => s.category === 'Programming');
  const docs        = skillsData.filter(s => s.category === 'Docs');

  return (
    <section id="skills" className="bg-gray-900 py-16">
      <div className="max-w-5xl mx-auto px-4">
        {/* Title */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-semibold text-white">
            My Skills
          </h2>
          <p className="text-gray-400 mt-3">
            A snapshot of the tools and technologies I use in research and development.
          </p>
        </div>

        {/* Two columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Programming */}
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">
              Programming
            </h3>
            <div className="space-y-4">
              {programming.map((item, index) => (
                <div
                  key={index}
                  className="bg-gray-800/80 hover:bg-gray-800 transition p-4 rounded-lg shadow"
                >
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-white font-medium">{item.skill}</span>
                    <span className="text-sm text-gray-300">{item.level}%</span>
                  </div>
                  <div className="w-full bg-gray-700 rounded-full h-2.5">
                    <div
                      className="h-2.5 rounded-full bg-blue-500"
                      style={{ width: `${item.level}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Document tools */}
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">
              Document preparation & tools
            </h3>
            <div className="space-y-4">
              {docs.map((item, index) => (
                <div
                  key={index}
                  className="bg-gray-800/80 hover:bg-gray-800 transition p-4 rounded-lg shadow"
                >
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-white font-medium">{item.skill}</span>
                    <span className="text-sm text-gray-300">{item.level}%</span>
                  </div>
                  <div className="w-full bg-gray-700 rounded-full h-2.5">
                    <div
                      className="h-2.5 rounded-full bg-blue-500"
                      style={{ width: `${item.level}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skill;
